import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import * as moment from 'moment';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from 'src/app/services/admin/admin.service';
import { DatePipe } from '@angular/common';
import { MessagesService } from 'src/app/services/message/messages.service';
import { EventsService } from 'src/app/services/events/events.service';
import { NgxSpinnerService } from 'ngx-spinner';



@Component({
    selector: 'app-license-create',
    templateUrl: './license-create.component.html',
    styleUrls: ['./license-create.component.less'],
    providers: [DatePipe]
  })
  export class LicenseCreateComponent implements OnInit {
    private licenseForm: FormGroup;

    constructor(private fb: FormBuilder, private active: NgbActiveModal, private admin: AdminService, private modal: NgbModal,
      private datePipe: DatePipe, private msg: MessagesService, private events: EventsService,  private load: NgxSpinnerService) { }

    ngOnInit() {
      this.init();
      }

      private init() {
        this.licenseForm = this.fb.group({
          'first_name': [null,[Validators.required]],
          'last_name':[null,[Validators.required]],
          'organization':[null,[Validators.required]],
          'email':[null,[Validators.required]],
          'phone':[null,[Validators.required]],
          'expired_date': [moment(), [Validators.required]],
          'app_version':[null,[Validators.required]]
        });

        const todaysDate = this.datePipe.transform(moment(), 'yyyy-MM-dd');
        this.licenseForm.get('expired_date').setValue(todaysDate);

      }

      public getForm() {
        return this.licenseForm;
      }

      public closeModal() {
        this.active.close();
      }

      public createLicense() {
        
        // license object
        const licenseObj = {
            first_name : this.licenseForm.value.first_name,
            last_name : this.licenseForm.value.last_name,
            organization : this.licenseForm.value.organization,
            email : this.licenseForm.value.email,
            phone : this.licenseForm.value.phone,
            expired_date : this.licenseForm.value.expired_date,
            app_version : this.licenseForm.value.app_version
        }
        this.admin.createLicense(licenseObj)
        .then(msg => this.success(msg))
        .catch(err => this.error(err));
    }

        // handle success
     private success(res) {
       this.load.hide();
       this.msg.success(res);
       this.resetField();
     }

  // handle error
    private error(err) {
      this.load.hide();
      this.msg.error(err);
    }

    // resets form field
    private resetField() {
      this.licenseForm.reset();
    }
  }
    